export function updateOrInsert(array = [], value, { key }) {
  const index = array.findIndex(elem => elem[key] == value[key]);

  if (index === -1) {
    return [value].concat(array);
  }

  return array.map(elem => {
    if (elem[key] == value[key]) {
      return value;
    }

    return elem;
  });
}

export function updateProperties(array = [], id, { key, value }) {
  return array.map(elem => {
    if (elem[key] == id) {
      return {
        ...elem,
        ...value,
      };
    }

    return elem;
  });
}

export function removeIfExists(array = [], value, { key }) {
  return array.filter(elem => elem[key] != value[key]);
}
